import React from 'react';
import { Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import QuotationPageRoute from './QuotationPageRoute';

const basePath = '/v2/quotation';

export default (
  <Route
    path={basePath}
    element={
      <MainLayout>
        <Outlet />
      </MainLayout>
    }
  >
    <Route path={`${basePath}/:quotationId/*`} element={<QuotationPageRoute />} />
    {/* v6 ranks a splat below an index route, so without this the parent's OWN path matches
        the layout alone and <Outlet /> renders nothing -- an empty 200, not the 404. */}
    <Route index element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
